<template>
  <div class="timeline">
    <input
      id="volume-range-slider"
      type="range"
      role="progressbar"
      class="progress-background icon-video-timeline focusable"
      :value="soundMuted ? 0 : volume"
      :aria-label="`Volume level indicator -- ${volume}%`"
      @change="e => updateVolume(+e.target.value)"
      :style="{
        background:
          volume === 0 || soundMuted
            ? '#dddddd'
            : `linear-gradient(to right, #6ec8c6 ${volume}%, #dddddd 5%)`,
        ...(sliderStyles ?? {})
      }"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const student = createNamespacedHelpers('student');
const application = createNamespacedHelpers('application');

export default {
  props: {
    sliderStyles: {
      type: Object,
      required: false
    }
  },
  computed: {
    ...student.mapState(['accessibilitySettings']),
    ...student.mapState({
      accessibilitySettings: state => state.accessibilitySettings,
      volume: state => state.accessibilitySettings.audioSettings.volume,
      soundMuted: state => state.accessibilitySettings.audioSettings.muteSounds
    }),

    ...application.mapState(['device', 'kwtMode', 'toolbarMode'])
  },

  methods: {
    ...student.mapMutations(['setAccessibilitySettings']),
    ...student.mapActions(['saveStudentSettings']),

    updateVolume(volumeNumber) {
      const volume = volumeNumber < 0 ? 0 : volumeNumber > 100 ? 100 : volumeNumber;
      const clonedSettings = { ...this.accessibilitySettings };
      clonedSettings.audioSettings.volume = volume;
      if (this.soundMuted && volume > 0) {
        clonedSettings.audioSettings.muteSounds = false;
      }
      if (!this.soundMuted && volume === 0) {
        clonedSettings.audioSettings.muteSounds = true;
      }
      this.setAccessibilitySettings(clonedSettings);
      this.saveStudentSettings();
    }
  }
};
</script>

<style lang="scss" scoped>
#volume-range-slider {
  -webkit-appearance: none;
  overflow: hidden;
  width: 80%;
  max-height: 12px;
  height: 25%;
  border-radius: 5px;
  border: 1px solid black;
  background-repeat: no-repeat;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  overflow: visible;
}

#volume-range-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 27px;
  height: 26px;
  max-height: 100%;
  max-width: 100%;
  cursor: pointer;
  background-image: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2230%22%20height%3D%2232%22%20viewBox%3D%220%200%2030%2032%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M19.1636%201.72501C14.7455%201.89167%205.22182%202.42501%202.47273%203.22501C1.98182%205.72501%201%2012.025%201%2017.225C1%2022.425%201.98182%2027.3917%202.47273%2029.225L10.3273%2029.725L22.1091%2028.725L27.0182%2027.725L28%2023.725C28%2020.5583%2027.9018%2013.325%2027.5091%209.72501C27.0182%205.22501%2025.5455%203.22501%2025.0545%202.72501C24.6618%202.32501%2020.9636%201.89167%2019.1636%201.72501Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M2.87798%202.00271C0.446975%203.23171%200.369975%203.59571%200.0989753%2015.2577C-0.271025%2031.1727%20-0.201025%2031.2687%2011.539%2030.9407C25.017%2030.5647%2027.843%2029.9317%2028.941%2027.0457C29.469%2025.6567%2029.59%2020.1617%2029.218%2014.4827C28.335%201.01771%2028.016%200.705708%2015.128%200.725708C9.28998%200.734708%204.37498%201.24671%202.87798%202.00271ZM25.307%204.28171C26.542%205.51771%2026.878%208.17371%2026.878%2016.7097V27.5667L21.628%2028.1317C18.74%2028.4427%2013.49%2028.8127%209.95998%2028.9537L3.54098%2029.2107L2.67298%2025.9277C2.19498%2024.1227%201.93298%2018.4977%202.09098%2013.4277L2.37798%204.21071L7.87798%203.62371C18.791%202.45871%2023.668%202.64371%2025.307%204.28171ZM7.60598%208.31571C6.56198%209.35971%206.70397%2024.7107%207.75797%2024.7107C8.84697%2024.7107%209.78098%2013.0607%208.94497%209.89871C8.60997%208.62771%208.00698%207.91471%207.60598%208.31571ZM13.585%2015.4067C12.991%2023.2537%2013.292%2025.1907%2014.947%2024.1677C16.115%2023.4457%2016.187%207.71071%2015.022%207.71071C14.552%207.71071%2013.905%2011.1737%2013.585%2015.4067ZM19.585%2015.4067C18.991%2023.2537%2019.292%2025.1907%2020.947%2024.1677C22.115%2023.4457%2022.187%207.71071%2021.022%207.71071C20.552%207.71071%2019.905%2011.1737%2019.585%2015.4067Z%22%20fill%3D%22black%22%2F%3E%3C%2Fsvg%3E');
  background-repeat: no-repeat;
  background-size: 80% auto;
  background-position-y: 50%;
  background-position-x: 50%;

  @media (max-width: 432px) {
    width: 12px;
    height: 11px;
  }
}
</style>
